import { Component, Input } from '@angular/core';
import { CaseData } from 'src/app/models/case-data.model';
import { MatDivider } from '@angular/material/divider';
import { TranslateModule } from '@ngx-translate/core';
import { DecimalPipe, DatePipe } from '@angular/common';

@Component({
  selector: 'app-claims-list',
  templateUrl: './claims-list.component.html',
  styleUrls: ['./claims-list.component.scss'],
  imports: [MatDivider, TranslateModule, DecimalPipe, DatePipe],
})
export class ClaimsListComponent {
  @Input({ required: true }) caseData!: CaseData;
}
